import { useState, useEffect } from 'react';

export function useLocalStorage(key, defaultValue) {
  const [value, setValue] = useState(() => {
    // Get initial value from localStorage or use default
    try {
      const storedValue = localStorage.getItem(key);
      console.log(`useLocalStorage hook retrieved storage item ${key}='${storedValue}'. Initializing state to stored value`)
      return storedValue ? JSON.parse(storedValue) : defaultValue;
    } catch (error) { 
      console.error(error);
      console.log(`useLocalStorage hook retrieved no stored value for ${key}. Initializing state to default value '${defaultValue}'`)
      return defaultValue;
    }
  });

  useEffect(() => {
    // Update localStorage whenever the state changes
    try { 
      localStorage.setItem(key, JSON.stringify(value));
      console.log(`useLocalStorage hook updated state value in storage to ${key}='${value}'`)
    } catch (error) { 
      console.error(error);
      console.log(`useLocalStorage hook failed to update state value in storage to ${key}='${value}'`)
    }
  }, [key, value]);

  // Optional: Add cross-tab synchronization with the 'storage' event listener
//   useEffect(() => {
//     const handleStorageChange = (event) => {
//       if (event.key === key && event.newValue !== null) {
//         try {
//           setValue(JSON.parse(event.newValue));
//         } catch (error) {
//           console.error(error);
//         }
//       }
//     };
//     window.addEventListener('storage', handleStorageChange);
//     return () => window.removeEventListener('storage', handleStorageChange);
//   }, [key]);

  return [value, setValue];
}

 